module.exports = __webpack_public_path__ + "img/logo.ff6f231a.svg";